import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { PaywallLock } from '../paywall-lock'
import { LinkedAccountLock_OfferLockDataFragment } from './__generated__/linked-account-lock.graphql'
import { AI_FEATURES, AiContent } from './ai-content'
import { Content } from './content'
import styles from './linked-account-lock.module.scss'
import { ModalLock } from './modal-lock'

interface LinkedAccountLockProps {
  offerLockData: LinkedAccountLock_OfferLockDataFragment
  featureCode?: string
}

export function LinkedAccountLock({ offerLockData, featureCode }: LinkedAccountLockProps) {
  const isAIFeature = featureCode ? AI_FEATURES.includes(featureCode) : false
  const Component = isAIFeature ? (
    <AiContent offerLockData={offerLockData} />
  ) : (
    <Content offerLockData={offerLockData} />
  )

  const { componentType } = useContext(BoxLockContext)
  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles.paywallCustomPlanLock}>
          {Component}
        </PaywallLock>
      )
    case 'modal':
      return (
        <ModalLock offerLockData={offerLockData} isAIVariant={isAIFeature}>
          {Component}
        </ModalLock>
      )
    default:
      return null
  }
}

LinkedAccountLock.fragments = {
  offerLockData: gql`
    fragment LinkedAccountLock_offerLockData on OfferLockData {
      ...LinkedAccountLockContent_offerLockData
      ...LinkedAccountLockModalLock_offerLockData
      ...PaywallLock_offerLockData
      ...LinkedAccountLockAiContent_offerLockData
    }

    ${Content.fragments.offerLockData}
    ${AiContent.fragments.offerLockData}
    ${ModalLock.fragments.offerLockData}
    ${PaywallLock.fragments.offerLockData}
  `,
}
